export default "__VITE_ASSET__e465e810__"